export const updateStep = (step, state, expanded) => ({
  ...step,
  state: state || step.state,
  expanded: expanded != null ? expanded : step.expanded,
});

export const updateMenuState = ({ menu, before = {}, current = {}, after = {}, common }) => {
  if (common) {
    const { state: stateComn, expanded: expandedComn } = common;

    return menu.map(step => updateStep(step, stateComn, expandedComn));
  }

  const { state: stateBfr, expanded: expandedBfr } = before;
  const { code, state, expanded } = current;
  const { state: stateAft, expanded: expandedAft } = after;
  let isBefore = true;

  return menu.map(step => {
    if (step.code === code) {
      isBefore = false;
      return updateStep(step, state, expanded);
    }

    if (isBefore) {
      return updateStep(step, stateBfr, expandedBfr);
    }

    return updateStep(step, stateAft, expandedAft);
  });
};
